(() => {
  async function init() {
    for (const marker of document.querySelectorAll('[data-category-bestsellers-url]:not([data-loading])')) {
      marker.dataset.loading = 'true';
      const track = marker.closest('.category-top-track');
      if (!track) continue;
      try {
        const url = new URL(marker.dataset.categoryBestsellersUrl, location.origin);
        url.search = new URLSearchParams({ section_id: 'gastro-category-bestsellers', sort_by: 'best-selling' });
        const response = await fetch(url);
        if (!response.ok) throw new Error('Best sellers unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const cards = [...doc.querySelectorAll('[data-category-bestseller-results] .gastro-product-card')];
        if (!cards.length) throw new Error('No best sellers returned');
        cards.forEach(card => card.classList.add('category-top-card'));
        track.replaceChildren(...cards);
        track.dataset.productOrder = 'best-selling';
        track.scrollLeft = 0;
        track.dispatchEvent(new Event('scroll'));
      } catch (error) {
        marker.dataset.loading = 'failed';
        console.warn('Category best sellers could not load', error);
      }
    }
  }
  init();
  document.addEventListener('shopify:section:load', init);
})();
